export const addPlusToPhone = (phone: string) => (phone[0] === '+' ? '' : '+') + phone;
